import { z } from 'zod';

/**
 * UserHoursData - Dati ore per utente per attività
 * Corrisponde all'oggetto anonimo creato nel controller C#
 */
export interface UserHoursData {
	/** Nome utente */
	userName: string;
	/** Array di ore per ogni attività (ordinato come activities) */
	data: number[]; // decimal[] serializzato come number[]
}

/**
 * HoursPerActivityPerUserChartData - Dati del grafico ore per attività per utente
 * Corrisponde alla response del controller GetHoursPerActivityPerUserChartData
 */
export interface HoursPerActivityPerUserChartData {
	/** Lista delle attività ordinate alfabeticamente (codici in maiuscolo) */
	activities: string[];
	/** Dati ore per utente */
	userHours: UserHoursData[];
}

/**
 * ActivityHoursData - Dati ore per singola attività
 * Corrisponde all'oggetto anonimo creato nel controller GetHoursPerActivityChartData
 */
export interface ActivityHoursData {
	/** Codice attività (in maiuscolo) */
	activityCode: string;
	/** Ore totali per l'attività */
	hours: number; // decimal serializzato come number
}

/**
 * HoursPerActivityChartData - Array di dati ore per attività
 * Corrisponde alla response del controller GetHoursPerActivityChartData
 */
export type HoursPerActivityChartData = ActivityHoursData[];

/**
 * Schema Zod per la validazione di UserHoursData
 */
export const UserHoursDataSchema = z.object({
	userName: z.string(),
	data: z.array(z.number()), // Array di decimal serializzati come number
});

/**
 * Schema Zod per la validazione di HoursPerActivityPerUserChartData
 */
export const HoursPerActivityPerUserChartDataSchema = z.object({
	activities: z.array(z.string()),
	userHours: z.array(UserHoursDataSchema),
});

/**
 * Schema Zod per la validazione di ActivityHoursData
 */
export const ActivityHoursDataSchema = z.object({
	activityCode: z.string(),
	hours: z.number(), // decimal serializzato come number
});

/**
 * Schema Zod per la validazione di HoursPerActivityChartData
 */
export const HoursPerActivityChartDataSchema = z.array(ActivityHoursDataSchema);
